var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Notification_Bell",
    "data-name": "Notification Bell",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,.586a.583.583,0,0,0,.58.586H6.24A.586.586,0,0,0,6.24,0H.58A.583.583,0,0,0,0,.586Z",
    transform: "translate(4.08 7.998)",
    fill: "#eb742e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M13.45,8.683,13.25,7.3a.582.582,0,0,0-.66-.5.591.591,0,0,0-.5.662l.27,1.875a.579.579,0,0,0,.58.5h.31a.586.586,0,0,1,0,1.172H1.76a.586.586,0,0,1,0-1.172h.31a.587.587,0,0,0,.58-.5l.63-4.5A4.246,4.246,0,0,1,5.11,1.892a4.369,4.369,0,0,1,2.45-.72A4.322,4.322,0,0,1,9.17,1.5.586.586,0,0,0,9.64.43,5.091,5.091,0,0,0,7.56,0,5.653,5.653,0,0,0,4.47.916,5.4,5.4,0,0,0,2.12,4.676L1.56,8.683a1.758,1.758,0,0,0,.2,3.5H13.25a1.758,1.758,0,0,0,.2-3.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M1.744,15A1.745,1.745,0,0,1,0,13.456a.581.581,0,0,1,.51-.649.585.585,0,0,1,.65.514.574.574,0,0,0,.58.508.574.574,0,0,0,.581-.508.592.592,0,0,1,1.05-.294.574.574,0,0,1,.12.429A1.751,1.751,0,0,1,1.744,15Zm4.54-9.141a.584.584,0,0,1-.58-.586V3.515H3.945a.586.586,0,1,1,0-1.172H5.7V.586a.585.585,0,1,1,1.17,0V2.344h1.76a.586.586,0,0,1,0,1.172H6.874V5.273A.588.588,0,0,1,6.285,5.859Z",
    transform: "translate(5.786)",
    fill: "#eb742e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellIcon);
export default __webpack_public_path__ + "static/media/Notification-Bell-icon.74690121646d052725529fcb143c44df.svg";
export { ForwardRef as ReactComponent };